import { DateRecurField } from '@uncinc/react-drupal-core/types';
import formatEventDates from './formatEventDates';

/**
 * @name Unpacked
 *
 * This type expects an array as parameter,
 * and returns the type of its array items.
*/
type Unpacked<T extends any[]> = T extends (infer U)[] ? U : T;

const eventDateInfo = (dates: DateRecurField[]) => {
  const formattedDates = formatEventDates(dates);

  let firstUpcomingDate = null as Unpacked<DateRecurField['dates']> | null;
  const today = new Date();

  formattedDates.forEach((date) => {
    if (new Date(date.start.date) > today) {
      if (firstUpcomingDate === null) {
        firstUpcomingDate = date;
      } else if (new Date(date.start.date) < new Date(firstUpcomingDate.start.date)) {
        firstUpcomingDate = date;
      }
    }
  });

  return {
    firstUpcomingDate,
    dates: formattedDates,
  };
};

export default eventDateInfo;
